import React from 'react';
import PropTypes from 'prop-types';

const LocationSwitcher = ({ flagUrl, language }) => (
  <div className="location-select">
    <div
      style={{ backgroundImage: `url(${flagUrl})` }}
      className="location-select__flag"
    />
    <p className="location-select__language">{language}</p>
  </div>
);

LocationSwitcher.propTypes = {
  flagUrl: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default LocationSwitcher;
